/** @jsx h */
import { labels } from '../config';
import CalendarList from '../components/CalendarList';
import SearchList from '../components/SearchList';

const ResultContainer = ({
  searchType,
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  switch (searchType) {
    case 'search':
      return (
        <SearchList
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    case 'calendar':
      return (
        <CalendarList
          allResultCount={allResultCount}
          list={list}
          pagination={pagination}
          loadMore={loadMore}
          pluginNamespace={pluginNamespace}
        />
      );
    default:
      return labels.search.unavailable;
  }
};

export default ResultContainer;
